<template>
  <base-radio-group
    :options="tags.map((t) => t.localized || (t.key ? $t(t.key) : t.name))"
    :model-value="
      isSelected?.localized ||
      (isSelected?.key ? $t(isSelected.key) : isSelected?.name)
    "
    :wrap-class="wrapClass"
    :background="background"
    :disabled="disabled || settingsDisabled"
    @input="(value) => updateFilter({ value: tags[value].name })"
  >
    <template v-if="filter.excluded && !form" #trailingInline="{ index }">
      <filter-box-exclude
        :toggled="filter.excluded?.includes(tags[index].name)"
        :filter="filter"
        @input="
          updateFilter({
            value: tags[index].name,
            filterIn: false,
          })
        "
      />
    </template>
  </base-radio-group>
</template>

<script>
import FilterBoxExclude from '@components/List/FilterBoxExclude.vue'
import { getTagOptions } from '@helpers/localizedTags.js'
import { computed, toRefs, inject, ref } from 'vue'

export default {
  components: {
    FilterBoxExclude,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    background: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Boolean,
      default: false,
    },
    wrapClass: {
      type: String,
      default: '',
    },
  },
  emits: ['update'],
  setup(props, { emit }) {
    const { filter } = toRefs(props)
    const settingsTags = inject('settingsTags', ref([]))

    const tags = getTagOptions(filter)

    const isSelected = computed(() => {
      const selected = filter.value.selected
      return selected[0] || selected[0] === 0
        ? tags.value.find((t) => t.name === selected[0])
        : null
    })

    const settingsDisabled = computed(() =>
      filter.value.tags.some((t) =>
        settingsTags.value.includes(t.toLowerCase())
      )
    )

    function updateFilter({ value, filterIn }) {
      emit('update', {
        id: filter.value.id,
        value,
        type: filter.value.type,
        filterIn,
      })
    }

    return {
      settingsDisabled,
      updateFilter,
      isSelected,
      tags,
    }
  },
}
</script>
